import { CommonModule, NgClass } from '@angular/common';
import {
  Component,
  OnInit,
  OnChanges,
  input,
  model,
  output,
  signal,
  computed,
  inject
} from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { BadgeModule } from 'primeng/badge';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { SidebarModule } from 'primeng/sidebar';
import { TooltipModule } from 'primeng/tooltip';
import {
  PortalAppView,
  ViewSwitcherService
} from 'src/app/services/view-switcher.service';
import { NavigationItem } from 'sustainment-component';

@Component({
  selector: 'app-main-top-navigation',
  templateUrl: './main-top-navigation.component.html',
  styleUrls: ['./main-top-navigation.component.scss'],
  imports: [
    TooltipModule,
    RouterLink,
    NgClass,
    OverlayPanelModule,
    SidebarModule,
    BadgeModule,
    CommonModule,
    RouterLink,
    RouterLinkActive
  ]
})
export class MainTopNavigationComponent implements OnChanges, OnInit {
  private _viewSwitcherService = inject(ViewSwitcherService);

  public appViews = this._viewSwitcherService.appViews;

  public names = input<string[] | null>(null);
  public companyName = input<string | null>();
  public topNavItems = input<Array<NavigationItem>>();
  public profileDropdownItems = input<Array<NavigationItem>>();
  public sortedSideNavItems = model<Array<NavigationItem>>();

  public signOut = output();
  public navigateTo = output();

  public display = signal<boolean>(false);
  public accountMenuToggle = signal<boolean>(false);

  public currentAppView = this._viewSwitcherService.currentAppView;
  public dropdownName = computed<string>(() => this.names()?.join(' ') || '');
  public userInitials = computed<string>(
    () =>
      this.names()
        ?.map(([name]) => name)
        .join(' ') || ''
  );

  public ngOnInit(): void {
    this.sortedSideNavItems.set(this.getSortedSideNavItems());
  }

  public ngOnChanges(): void {
    this.sortedSideNavItems.set(this.getSortedSideNavItems());
  }

  public logout(): void {
    this.signOut.emit();
  }

  private getSortedSideNavItems(): Array<NavigationItem> {
    if (!this.sortedSideNavItems()?.find((e) => e.position && e.position > 0))
      return this.sortedSideNavItems() || [];

    return (
      this.sortedSideNavItems()?.sort((a, b) => a.position! - b.position!) || []
    );
  }

  public toggleAccountMenu(): void {
    this.accountMenuToggle.update((currentState) => !currentState);
  }

  public openExternalLink(item: NavigationItem): void {
    window.open(item.url, '_blank');
    this.resetBodyBlock();
  }

  public resetBodyBlock(): void {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('block');
  }

  public switchAppView(view: PortalAppView): void {
    this._viewSwitcherService.setAppView(view, { resetToHome: true });
  }
}
